<template>
  <v-container class="ma-0 pa-0" style="max-height:100% !important; overflow:scroll">
    <v-btn fab fixed bottom right v-show="mode != 'detail'" @click="addNew">
      <v-icon>
        mdi-plus
        </v-icon>
      </v-btn>
  <v-window v-model="mode">
      <v-window-item value="master">
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="Catalogo"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.categoria }}</td>
            <td class="text-xs-right">{{ props.item.precio }}</td>
            <td class="text-xs-right">{{ props.item.stock }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="editItem(props.item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(props.item)"
              >
                mdi-delete
              </v-icon>
            </td>
          </template>
          <template v-slot:no-data>
            Aun no has agregado productos a tu Negocio
          </template>
        </v-data-table>
      </v-window-item>
      <v-window-item lazy value="detail">
        <v-card >
          <v-layout class="pa-2">
            
                <v-flex xs3 v-if="selected.Images && selected.Images.length>0">
                  <v-img :src="selected.Images[0]" height="auto" width="100%" contain></v-img>
                  <v-container v-bind="{ [`grid-list-sm`]: true }" fluid class="pa-0 ma-0">
                    <v-layout row wrap v-if="selected.Images.length>1">
                      <v-flex
                        v-for="n in 9"
                        :key="n"
                        xs4
                      >
                      <thumbImg v-for="pImg in selected.Images.splice(0, 1)" :key="pImg.key" :imgKey="pImg.key"></thumbImg>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  
                </v-flex>
                <v-flex xs3 v-else text-xs-center> 
                  <v-avatar size="100px" tile color="indigo">
                    <v-icon x-large>mdi-camera</v-icon>
                  </v-avatar>
                    <br>
                  <span class="font-weight-thin font-italic">Una foto de calidad, ayuda a los clientes enamorarse de tu producto</span>
                  <v-btn flat>
                    <v-icon class="mx-2">mdi-cloud-upload</v-icon>
                    Subir Foto
                  </v-btn>
                </v-flex>
        <v-flex xs9>
            <v-card-title>
          <span class="headline">{{selected.key ? selected.name : 'Nuevo Producto'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 >
                <v-text-field label="Nombre Corto" v-model="selected.name" required></v-text-field>
              </v-flex>
              <v-flex xs12 >
                <v-textarea rows="3" auto-grow label="Descripcion" v-model="selected.descripcion" ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Precio*" v-model="selected.precio" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <categorias v-model="selected.categorias"/>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*Indica Campos obligatorios</small>
        </v-card-text>
                </v-flex>
              </v-layout>
       
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      
      </v-window-item>
      </v-window >

  </v-container>
</template>

<script>
  export default {
    components: {
      thumbImg: () => import('@/components/tienda/tumbpic'),
      categorias: () => import('@/components/tienda/categorias')
    },
    data: () => ({
      dialog: false,
      mode: 'master',
      saveLoading: false,
      loading: true,
      search: '',
      headers: [
        {
          text: 'Nombre',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Categoria', value: 'categoria' },
        { text: 'Precio', value: 'precio' },
        { text: 'Exist', value: 'stock' }
      ],
      Catalogo: [],
      selected: {
          name: '',
          categorias: [],
          precio: 0.00,
          stock: 0,
          Images: []
        }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Producto' : ''
      }
    },
    created () {
      this.cargaItems()
    },
    methods: {
      addNew () {
        // todo: add default values
        this.selected = {
          name: '',
          categorias: [],
          precio: 0.00,
          stock: 0,
          Images: []
        }
        this.mode = 'detail'
      },
      cargaItems () {
        this.$System.currentUser.ref.child('Negocio').on('value', Negsnap => {
          let CatRef = this.$db.ref(`/Negocios/${Negsnap.val()}/Catalogo`)
          CatRef.on('child_added', s => {
            let i = s.val()
            i['key'] = s.key
            this.Catalogo.push(i)
          })
          CatRef.on('child_removed', snap => {
            let removed = this.Catalogo.find(item => item.key === snap.key)
            delete this.Catalogo[this.Catalogo.indexOf(removed)]
          })
          CatRef.on('child_changed', snap => {
            let changed = this.Catalogo.find(item => item.key === snap.key)
            let i = snap.val()
            console.log('changed')
            console.dir(i)
            i['key'] = snap.key
            this.Catalogo[this.Catalogo.indexOf(changed)] = i
          })
          this.loading = false
        })
      },
      editItem (item) {
        console.dir(item)
        this.selected = item
        this.mode = 'detail'
      },
      deleteItem (item) {
        if (confirm('Seguro deseas eliminarlo?')) {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo`).child(item.key).delete()
        }
      },
      close () {
        this.mode = 'master'
        this.selected = {}
      },
      save () {
        this.saveLoading = true
        let d = JSON.parse(JSON.stringify(this.selected))
        delete d['key']
        console.log('saving')
        console.dir(this.selected)
        if (!this.selected.key) {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo`).push(d)
          .then(ok => {
            this.saveLoading = false
            this.close()
          }).catch(err => {
            this.saveLoading = false
            this.$Bus.$emit('ALERT', {type: 'error', text: err})
          })
        } else {
          this.$db.ref(`/Negocios/${this.$System.currentUser.Negocio.id}/Catalogo/${this.selected.key}`).set(d)
          .then(ok => {
            this.saveLoading = false
            this.close()
          }).catch(err => {
            this.saveLoading = false
            this.$Bus.$emit('ALERT', {type: 'error', text: err})
          })
        }
      }
    }
  }
</script>
